// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bd8uO","name":"styles_name__qkchV","id":"styles_id__BDONg"};